import { Row, Col, Divider, Descriptions, Input, Select, Space, Flex } from 'antd';
import { BaseContainer } from 'components/containers';
import { useLocation, useNavigate } from 'react-router-dom';
import { Editor, FillButton, OutlinedButton } from 'components/elements';
import { useCallback, useState } from 'react';
import { getLocalStorage } from 'hooks/useLocalStorage';
import { postCustomerCenterFaqAPI } from 'api/customer-center';
import { customerCenterFaqTypeOptions } from 'data/options';
import { URL_ADMIN } from 'routes/AdminRoute';
import { URL_CUSTOMER_CENTER_FAQ, URL_CUSTOMER_CENTER_PRODUCT_FAQ } from 'routes/CommonRoute';

export default function CustomerCenterFaqAdd() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { product_fg } = state;

  const [value, setValue] = useState({
    faq_type: '1'
  });

  const fnAddCustomerCenterFaq = async () => {
    const { user_name } = getLocalStorage('persist:user');
    if (!value?.title) {
      alert('제목을 입력해주세요.')
      return false;
    }
    if (!value?.content) {
      alert('내용을 입력해주세요.')
      return false;
    }
    const data = {
      faq_type: value?.faq_type,
      writer: user_name,
      title: value?.title,
      content: value?.content,
      product_fg: product_fg ? product_fg : 0
    };

    await postCustomerCenterFaqAPI(data)
      .then((res) => {
        if (res?.status === 200) {
          alert('작성이 완료되었습니다.');
          const url = product_fg === 0 ?  `${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ}` : product_fg === 1 ? `${URL_ADMIN}${URL_CUSTOMER_CENTER_PRODUCT_FAQ}` : null;
          navigate(url);
        } else alert('다시 시도해주세요.');
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fnHandleAdd = useCallback((v) => {
    setValue((value) => ({
      ...value,
      ...v
    }));
  }, []);

  const items1 = [
    {
      key: '1',
      label: '카테고리',
      children: <Select value={value?.faq_type} style={{ width: '30rem' }} options={customerCenterFaqTypeOptions?.slice(1)} onSelect={(v) => fnHandleAdd({ faq_type: v })} />
    },
    {
      key: '2',
      label: '제목',
      children: <Input value={value?.title} onChange={(e) => fnHandleAdd({ title: e.target.value })} />
    },
    {
      key: '3',
      label: '내용',
      children: (
        <>
          <Editor 
            height="340px" 
            data={value?.content} 
            onChange={(v) => fnHandleAdd({ content: v })} 
          />
        </>
      )
    }
  ];

  return (
    <>
      <BaseContainer>
        <Row>
          <Col span={24}>
            <Descriptions bordered column={1} labelStyle={{ width: '16rem' }} contentStyle={{ textAlign: 'left' }} items={items1} />
          </Col>
        </Row>
        <Divider className="divider" />
        <Flex justify="flex-end">
          <Space>
            <FillButton label="작성완료" backgroundColor="var(--color-gray03)" onClick={fnAddCustomerCenterFaq} />
            <OutlinedButton label="목록" color={'var(--color-gray03)'} onClick={() => navigate(product_fg === 0 ?  `${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ}` : product_fg === 1 ? `${URL_ADMIN}${URL_CUSTOMER_CENTER_PRODUCT_FAQ}` : null)} />
          </Space>
        </Flex>
      </BaseContainer>
    </>
  );
}
